<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <HiddenH1 />
  <ContentfulDynamicPage
    v-bind="$attrs"
    :page-type-name="PageTypeName.LandingPage"
  />
</template>

<script lang="ts" setup>
import { PageMetaKey } from '~/types/pages/page-meta-key.types'
import { TrackingPageType, PageTypeName } from '~/types/pages/page-type.types'

definePageMeta({
  key: PageMetaKey.CmsPages,
})

const pageMetaStore = usePageMetaStore() // Destructuring breaks top-lvl refs

onMounted(() => {
  pageMetaStore.setTrackingPageType(TrackingPageType.LandingPage)
})
</script>
